export const MODAL_STEPS = {
  KNOW: 0,
  SPEED: 1,
  STABILITY: 2,
  SAFETY: 3,
  SETTUP: 4,
};

export const STEPS_NAMES = {
  0: 'know',
  1: 'speed',
  2: 'stability',
  3: 'safety',
  4: 'settup',
};
